import { canShowSketchPropertySection, handleSketchEntityPropertyConfirm, registerPropertyManagerSection } from '@/core';
import { SketchEllipseCommand } from '@puppycad/cad-core';
import EllipsePropertySection from '@/components/editor/property-manager/ellipse/EllipsePropertySection.vue';

registerPropertyManagerSection({
  id: SketchEllipseCommand.Ellipse,
  title: '椭圆',
  order: 13,
  component: EllipsePropertySection,
  actions: {
    confirm: true,
  },
  onConfirm: handleSketchEntityPropertyConfirm,
  isApplicable: (context) => canShowSketchPropertySection(context, context.ellipsePropertyVisible === true),
});
